import { IError } from '@checkout/errors';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { SvgIcon } from '..';
import messages from '../../../i18n/base-en';
import * as Styles from './Messages.scss';

interface IOwnProps extends InjectedIntlProps {
  type: 'error' | 'success';
  title: string;
  errors?: IError;
  onClick: (event: React.SyntheticEvent<HTMLButtonElement>) => void;
}

const Messages: React.SFC<IOwnProps> = ({ type, title, errors, onClick, intl }) => {
  if (!errors) { return null; }

  const { formatMessage } = intl;

  return (
    <div className={Styles.messages}>
      <div className={Styles.icon}>
        <SvgIcon icon={type} />
      </div>
      <div className={Styles.title}>{title}</div>
      {errors.code && <div className={Styles.code}>Error code: {errors.code}</div>}
      {errors.title && <div className={Styles.name}>{errors.title}</div>}
      {errors && errors.messages && errors.messages.length > 0 && (
        <div className={Styles.messagesList}>
          {errors.messages.map((message) => {
            return <div className={Styles.message} key={message}>{message}</div>;
          })}
        </div>
      )}

      {errors.details && errors.details.stack && (
        <div className={Styles.messagesList}>
          <div className={Styles.message}>{errors.details.stack}</div>
        </div>
      )}

      {errors.message && (
        <div className={Styles.messagesList}>
          <div className={Styles.message}>{errors.message}</div>
        </div>
      )}

      <div className={Styles.buttonWrapper}>
        <button className={Styles.button} onClick={onClick}>{formatMessage(messages.information_button_label)}</button>
      </div>
    </div>
  );
};

export default injectIntl(Messages);
